import { render, staticRenderFns } from "./TheSourceMenuItem.vue?vue&type=template&id=0fa9d3f4&scoped=true&"
import script from "./TheSourceMenuItem.vue?vue&type=script&lang=js&"
export * from "./TheSourceMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./TheSourceMenuItem.vue?vue&type=style&index=0&id=0fa9d3f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa9d3f4",
  null
  
)

export default component.exports